module.exports = __webpack_public_path__ + "img/charging-hub-suggestion.8561d5d3.png";